/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheapprenantValidationcemasseDto } from './FcbRechercheapprenantValidationcemasseDto';
import {
    FcbRechercheapprenantValidationcemasseDtoFromJSON,
    FcbRechercheapprenantValidationcemasseDtoFromJSONTyped,
    FcbRechercheapprenantValidationcemasseDtoToJSON,
} from './FcbRechercheapprenantValidationcemasseDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheapprenantValidationcemasseDtoPaginatedResults
 */
export interface FcbRechercheapprenantValidationcemasseDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheapprenantValidationcemasseDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheapprenantValidationcemasseDto>}
     * @memberof FcbRechercheapprenantValidationcemasseDtoPaginatedResults
     */
    results?: Array<FcbRechercheapprenantValidationcemasseDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheapprenantValidationcemasseDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheapprenantValidationcemasseDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheapprenantValidationcemasseDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheapprenantValidationcemasseDtoPaginatedResultsFromJSON(json: any): FcbRechercheapprenantValidationcemasseDtoPaginatedResults {
    return FcbRechercheapprenantValidationcemasseDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheapprenantValidationcemasseDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheapprenantValidationcemasseDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheapprenantValidationcemasseDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheapprenantValidationcemasseDtoPaginatedResultsToJSON(value?: FcbRechercheapprenantValidationcemasseDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheapprenantValidationcemasseDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

